import script from "./GlobalFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalFooter.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalFooter.vue?vue&type=style&index=0&id=5bed700f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bed700f"]])

export default __exports__